import React, { Component } from 'react';
import UrlParse from 'url-parse';
import moment from 'moment';
import { Space } from 'antd';
import { Table } from 'antd';
import Loading from '../../../components/loading';
import GeneralHelper from '../../../helpers/general';

export class UsageHistoryListPage extends Component {

	componentDidMount() {
		this.getEquipmentUsageHistory();
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta } = prevProps.pageProps;
		const { meta } = this.props.pageProps;
		if (meta && meta !== prevMeta) {
			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};
			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	getEquipmentUsageHistory = async opts => {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { id } = query;

		this.props.getEquipmentUsageHistory({ id });
	}

	render() {
		const { loading, usage_history } = this.props.pageProps;

		// if no render dataIndex is a must....
		const columns = [
			{
				title: 'User',
				dataIndex: 'user_name',
				key: 'user_name',
				render: (user_name) => GeneralHelper.truncateString(user_name)
			},
			{
				title: 'Equipment',
				dataIndex: 'equipment',
				key: 'equipment',
				render: (equipment) => GeneralHelper.truncateString(equipment, 75)
			},
			{
				title: 'Check-in Time',
				key: 'check_in',
				render: data => {
					return (
						<Space size="middle">
							<p> {data.check_in && moment(data.check_in).format('MMM D, YYYY, hh:mm A') } </p>
						</Space>
					);
				}
			},
			{
				title: 'Check-out Time',
				key: 'check_out',
				render: data => {
					return (
						<Space size="middle">
							<p> {data.check_out && moment(data.check_out).format('MMM D, YYYY, hh:mm A')} </p>
						</Space>
					);
				}
			}
		];
		return (
			<>
				{ loading ?
					<Loading /> :
					<Table
						rowKey={usage => usage._id}
						columns={columns}
						dataSource={usage_history}
						style={{ width: '100%' }}
						scroll={{ x: 400 }}
					/>
				}
			</>
		);
	}
}

export default UsageHistoryListPage;
